import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalTitle
} from '@/components/ui/modal-atoms/ModalAtoms'
import {useTranslation} from '@/translations/i18n'
import {UserContractualDataForm} from '@/features/users/components/user-contractual-data-form/UserContractualDataForm'
import {Spinner} from '@/components/ui/spinner/Spinner'

export const UserContractualDataFormModal = ({
    onConfirmUpdate,
    isLoading,
    onCancel
}: {
    onConfirmUpdate: () => void
    isLoading: boolean
    onCancel: () => void
}) => {
    const {t} = useTranslation()

    return (
        <>
            <ModalOverlay />
            <Modal width="800px" overflowY="visible">
                <ModalHeader>
                    <Flexbox justify="space-between" align="center" fullWidth>
                        <ModalTitle>{t('users:contractual_data')}</ModalTitle>
                        <Button onClick={onCancel} variant="ghost">
                            <XCloseIcon />
                        </Button>
                    </Flexbox>
                </ModalHeader>
                <ModalBody>
                    <UserContractualDataForm />
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onCancel} variant="secondary">
                        {t('commons:cancel')}
                    </Button>
                    <Button type="submit" onClick={onConfirmUpdate} variant="primaryNeutral" disabled={isLoading}>
                        {isLoading && <Spinner />}
                        {t('commons:confirm')}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
